import type { AssetAllocationSlice } from '../api/chartDataTypes';

export type AssetAllocationSummary = {
    /** Plain-text version — used by the NVDA live region. */
    text: string;
    /** Same content with the percentage wrapped in <strong> for the visual
     *  banner. HTML-escapes the label + display tokens so values containing
     *  characters like `<` render literally instead of being parsed as a tag. */
    html: string;
};

function escapeHtml(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** Strip a trailing `%` (with optional whitespace) from a display string so the
 *  NVDA text variant can append the spelled-out word "percent". The HTML
 *  variant keeps the original display untouched. */
function stripPercent(display: string): string {
    return display.replace(/\s*%\s*$/, '');
}

/**
 * "Domestic: 92.8 percent."
 *
 * Spells out `percent` in the text variant because NVDA's default punctuation
 * level does not reliably read `%`. The backend's `display` already carries
 * `%` (e.g. "92.8%"), so the text variant strips it before appending the word;
 * the HTML variant keeps it as-is for visual brevity.
 */
export function buildAssetAllocationSummarySentence(slice: AssetAllocationSlice): AssetAllocationSummary {
    return {
        text: `${slice.label}: ${stripPercent(slice.display)} percent.`,
        html: `${escapeHtml(slice.label)}: <strong>${escapeHtml(slice.display)}</strong>.`,
    };
}
